import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useBreakpointUp } from '@travel-frontend/core';
import { useTranslation } from 'react-i18next';
import { ButtonWrapper } from '../../../../components/ImageGalleryLayer/components/CategoryTabs/components/ButtonWrapper.js';
import { Container } from '../../../../components/ImageGalleryLayer/components/CategoryTabs/components/Container.js';
import { Badge } from '../../../../components/ImageGalleryLayer/components/MainContent/components/Badge.js';
import { Button } from '../../../../components/ImageGalleryLayer/components/MainContent/components/Button.js';
import { Label } from '../../../../components/ImageGalleryLayer/components/MainContent/components/Label.js';
import { useTracking } from '../../../../hooks/index.js';
import { Stack, Tab, Tabs } from '../../../../primitives/index.js';
import { priceFormatter } from '../../../../utils/index.js';
export const CategoryTabs = ({
  activeTabIndex,
  onTabChange,
  backgroundColor,
  color,
  groupedData,
  ctaButton: ctaButtonProperty,
  offerPrice,
  onOfferButtonClick,
  isOverview
}) => {
  const {
    t
  } = useTranslation('imageGalleryLayer');
  const lgUp = useBreakpointUp('lg');
  const {
    trackClickEvent
  } = useTracking();
  const ctaButtonElement = offerPrice && _jsx(Button, {
    onClick: onOfferButtonClick,
    children: t('offersFrom', {
      value: priceFormatter(offerPrice.locale, offerPrice.currency).format(offerPrice.amount)
    })
  });
  const handleTabChange = index => {
    const category = Object.keys(groupedData).at(index);
    onTabChange(index);
    if (category) {
      trackClickEvent('gallery_category', {
        event: 'gallery',
        click_text: category
      });
    }
  };
  return _jsxs(Container, {
    isOverview: isOverview,
    hasBtn: Boolean(ctaButtonProperty || offerPrice),
    children: [_jsx(Tabs, {
      value: activeTabIndex,
      backgroundColor: backgroundColor,
      onChange: handleTabChange,
      children: Object.entries(groupedData).map(([key, value], index) => _jsx(Tab, {
        backgroundColor: backgroundColor,
        color: color,
        label: _jsxs(Stack, {
          direction: "row",
          spacing: "xSmall",
          alignItems: "center",
          children: [_jsx(Label, {
            active: index === activeTabIndex,
            children: t(key)
          }), _jsx(Badge, {
            children: value.length
          })]
        }),
        size: "medium"
      }, key))
    }), lgUp && (ctaButtonProperty || offerPrice) && _jsx(ButtonWrapper, {
      children: ctaButtonProperty || ctaButtonElement
    })]
  });
};